module.exports = __webpack_public_path__ + "static/media/blockchain-optimized.6fd1054a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/slides/05-why-gatsby/images/blockchain-optimized.jpg
// module id = 954
// module chunks = 0